export default function HowWeWork() {
  const steps = [
    {
      number: '01',
      icon: 'ri-line-chart-line',
      title: 'Оцифровка и Аналитика',
      subtitle: 'Нельзя управлять тем, что нельзя измерить',
      description: 'Первый шаг — внедрение стандартов отчетности',
      features: [
        'Настройка счетчиков и целей',
        'Внедрение сквозной аналитики',
        'Разметка всего трафика (UTM-метки) для контроля эффективности каждого объявления'
      ],
      color: 'from-[#C5A880] to-[#B39770]',
      bgColor: 'from-[#F8F9FA] to-[#F8F9FA]',
      borderColor: 'border-[#C5A880]/30'
    },
    {
      number: '02',
      icon: 'ri-route-line',
      title: 'Проектирование Воронки Продаж',
      subtitle: 'Мы не просто «льем трафик на сайт»',
      description: 'Мы строим продуманный путь клиента',
      features: [
        'Разделение трафика на «холодный», «теплый» и «горячий»',
        'Создание посадочных страниц под конкретные сегменты аудитории',
        'Внедрение автоворонок для прогрева тех, кто не готов купить сразу'
      ],
      color: 'from-[#1A2B4C] to-[#2A3B5C]',
      bgColor: 'from-[#F8F9FA] to-[#F8F9FA]',
      borderColor: 'border-[#1A2B4C]/30'
    },
    {
      number: '03',
      icon: 'ri-flask-line',
      title: 'Тестирование Гипотез',
      subtitle: 'Маркетинг — это математика, а не магия',
      description: 'HADI-циклы для постоянного улучшения',
      features: [
        'Выдвигаем гипотезу («этот заголовок повысит конверсию»)',
        'Быстро тестируем на реальной аудитории',
        'Замеряем результат и внедряем или отбрасываем'
      ],
      color: 'from-[#C5A880] to-[#B39770]',
      bgColor: 'from-[#F8F9FA] to-[#F8F9FA]',
      borderColor: 'border-[#C5A880]/30'
    },
    {
      number: '04',
      icon: 'ri-rocket-line',
      title: 'Масштабирование',
      subtitle: 'Когда найдена рабочая связка',
      description: '«Канал — Оффер — Прибыль»',
      features: [
        'Масштабируем бюджет на проверенные каналы',
        'Система позволяет расти кратно (x2, x3, x5)',
        'Сохраняем рентабельность при увеличении объемов'
      ],
      color: 'from-[#1A2B4C] to-[#2A3B5C]',
      bgColor: 'from-[#F8F9FA] to-[#F8F9FA]',
      borderColor: 'border-[#1A2B4C]/30'
    },
    {
      number: '05',
      icon: 'ri-robot-2-line',
      title: 'Автоматизация',
      subtitle: 'Передача рутины роботам и скриптам',
      description: 'Освобождаем время для стратегии',
      features: [
        'Автоматические отчеты и уведомления',
        'Роботизация повторяющихся процессов',
        'Фокус команды на стратегических задачах, а не на рутине'
      ],
      color: 'from-[#C5A880] to-[#B39770]',
      bgColor: 'from-[#F8F9FA] to-[#F8F9FA]',
      borderColor: 'border-[#C5A880]/30'
    }
  ];

  const benefits = [
    {
      icon: 'ri-eye-line',
      title: 'Видеть реальный доход',
      description: 'ROI/ROMI с каждого вложенного рубля'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Решения на основе цифр',
      description: 'А не интуиции или догадок'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Предсказуемый конвейер',
      description: 'Без зависимости от «звездных» сотрудников'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white via-[#F8F9FA] to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-3 bg-gradient-to-r from-[#C5A880] to-[#B39770] text-white rounded-full mb-6">
            <span className="font-bold text-lg font-['Montserrat']">🔄 Переход от хаоса к системе</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-6 font-['Playfair_Display']">
            Как мы работаем
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-['Montserrat']">
            5 этапов построения системы — пошаговый процесс трансформации вашего маркетинга
          </p>
        </div>

        {/* Steps */}
        <div className="space-y-8 mb-20">
          {steps.map((step, index) => (
            <div 
              key={index}
              className={`bg-gradient-to-br ${step.bgColor} rounded-3xl p-8 md:p-10 border-2 ${step.borderColor} hover:shadow-2xl transition-all duration-300 group`}
            >
              <div className="flex flex-col md:flex-row gap-8 items-start">
                {/* Left: Number & Icon */}
                <div className="flex-shrink-0">
                  <div className={`w-24 h-24 bg-gradient-to-br ${step.color} rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-xl`}>
                    <i className={`${step.icon} text-4xl text-white`}></i>
                  </div>
                  <div className={`text-6xl font-black bg-gradient-to-br ${step.color} bg-clip-text text-transparent opacity-30 font-['Playfair_Display']`}>
                    {step.number}
                  </div>
                </div>

                {/* Right: Content */}
                <div className="flex-1">
                  <h3 className="text-3xl font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display']">
                    {step.title}
                  </h3>
                  <p className="text-lg text-gray-700 mb-2 font-['Montserrat']">
                    <strong>{step.subtitle}</strong>
                  </p>
                  <p className="text-gray-600 mb-6 font-['Montserrat']">
                    {step.description}
                  </p>

                  <div className="space-y-3">
                    {step.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-3">
                        <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 shadow-md">
                          <i className="ri-check-line text-green-600 text-sm font-bold"></i>
                        </div>
                        <span className="text-gray-700 leading-relaxed font-['Montserrat']">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Block */}
        <div className="bg-gradient-to-br from-[#1A2B4C] via-[#2A3B5C] to-[#1A2B4C] rounded-3xl p-10 md:p-16 text-white relative overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-64 h-64 bg-[#C5A880] rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#C5A880] rounded-full blur-3xl"></div>
          </div>

          <div className="relative z-10">
            <div className="text-center mb-12">
              <div className="inline-block px-6 py-2 bg-red-500/20 border border-red-500/50 rounded-full mb-6">
                <span className="text-red-300 font-semibold font-['Montserrat']">⚠️ Перестаньте сливать деньги на неэффективные инструменты</span>
              </div>
              <h3 className="text-3xl md:text-4xl font-bold mb-6 font-['Playfair_Display']">
                Системный подход позволяет владельцу бизнеса:
              </h3>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mb-10">
              {benefits.map((benefit, index) => (
                <div 
                  key={index}
                  className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-[#C5A880] to-[#B39770] rounded-xl flex items-center justify-center mb-4">
                    <i className={`${benefit.icon} text-2xl text-white`}></i>
                  </div>
                  <h4 className="text-xl font-bold mb-2 font-['Montserrat']">{benefit.title}</h4>
                  <p className="text-gray-300 font-['Montserrat']">{benefit.description}</p>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-r from-[#C5A880]/20 to-[#B39770]/20 border-2 border-[#C5A880]/50 rounded-2xl p-8 text-center">
              <div className="flex items-center justify-center gap-3 mb-4">
                <i className="ri-shield-check-line text-4xl text-[#C5A880]"></i>
                <h4 className="text-2xl font-bold font-['Playfair_Display']">Мы продаем не «настройку рекламы»</h4>
              </div>
              <p className="text-xl text-gray-200 font-['Montserrat']">
                А <strong className="text-white">«построение системы»</strong> = Стратегия + Инструменты + Команда
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}